/** @format */
import {isValid, parseISO} from 'date-fns';

export interface ParsedDate {
  isValid: boolean;
  parsedEndDate: Date;
}

const parseEndDate = (endDate?: string | null): ParsedDate => {
  const parsedEndDate = parseISO(endDate ?? '');
  const isValidDate = isValid(parsedEndDate);
  return {
    isValid: isValidDate,
    parsedEndDate,
  };
};

export {parseEndDate};
